module.exports = __webpack_public_path__ + "static/media/chilli-heat.ec816ade.gif";